import React from "react";
import DataTable from "../../../components/DataTable";

export default function UnitAdhocReportTable({ columns, data }) {
  const options = {
    columns: columns || [],
    dataSource: data || [],
    sx: { height: 350 },
    rowIdProperty: "ReportNumber",
    isDisableColumnFilter: true,
    rowStylingHandler: "sample",
  };
  return <DataTable {...options} />;
}
